import { render, staticRenderFns } from "./GalleryStrip.vue?vue&type=template&id=3a09b3a2&"
import script from "./GalleryStrip.vue?vue&type=script&lang=ts&"
export * from "./GalleryStrip.vue?vue&type=script&lang=ts&"
import style0 from "./GalleryStrip.vue?vue&type=style&index=0&id=3a09b3a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports